import { render, staticRenderFns } from "./StandardDeviation.vue?vue&type=template&id=2dd4bb15&scoped=true&"
import script from "./StandardDeviation.vue?vue&type=script&lang=js&"
export * from "./StandardDeviation.vue?vue&type=script&lang=js&"
import style0 from "./StandardDeviation.vue?vue&type=style&index=0&id=2dd4bb15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd4bb15",
  null
  
)

export default component.exports